import React, { useState } from "react";

import { auth } from "_firebase";

// import { resetPasswordLinkAPI } from "utils/auth/api";

import Button from "components/Button";
import Input from "components/Input";

import classes from "../style.module.scss";

import VoltaLogo from "assets/images/logo-color.svg";

const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

const PasswordReset = () => {
    const [email, setEmail] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);

    const handleReset = async (e) => {
        e.preventDefault();

        //! This is for testing, you need to copy and paste link from console.log on line 27
        // const res = await resetPasswordLinkAPI(email);

        // console.log(
        //     `localhost:3000/password-reset/new-password?oobCode=${
        //         res.data.link
        //             .split("&")
        //             .find((el) => el.includes("oobCode"))
        //             .split("=")[1]
        //     }`
        // );

        setEmail("");
        setIsSuccess(true);

        setTimeout(() => {
            setIsSuccess(false);
        }, 3000);

        // const actionCodeSettings = {
        //     url: `http://localhost:3000/password-reset?email=${email}`,
        //     handleCodeInApp: false,
        // };

        //! This is for production and when you change link in /project/volta-snap-ca/authentication/emails
        auth.sendPasswordResetEmail(email)
            .then(() => {
                setIsSuccess(true);
                setEmail("");

                setTimeout(() => {
                    setIsSuccess(false);
                }, 5000);
            })
            .catch((error) => {
                console.log(error.message);
            });
    };

    return (
        <div className={classes.authWrapper}>
            <div className={classes.formWrapper}>
                <div className={classes.top}>
                    <img src={VoltaLogo} alt="Volta Snap logo in colour" />
                    <h2>Password Reset</h2>
                </div>
                {isSuccess && (
                    <h3 style={{ margin: "10px 0", color: "#0eb0a9", fontSize: "14px" }}>
                        We've sent a password reset link to your email address.
                    </h3>
                )}
                <form className={classes.form}>
                    <Input
                        type="email"
                        label="Email Address"
                        placeholder="Your Email"
                        input={{
                            value: email,
                            onChange: (e) => setEmail(e),
                        }}
                    />
                    <Button
                        type="submit"
                        className={classes.submit}
                        disabled={!emailRegex.test(email)}
                        onClick={handleReset}
                    >
                        Reset Password
                    </Button>
                </form>
            </div>
        </div>
    );
};

export default PasswordReset;
